import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import { Person as PersonIcon } from "@mui/icons-material";
import { ProfileView } from "../../../../services/ProfileService/types/profileTypes";
import { RoleSelect } from "../fieldEditors/RoleSelect";
import { SectionPaper, SectionHeader } from "../../../common/components/styled-ui-elements";
import { THEME_COLORS } from "../../utils/profileUtils";

interface ProfileInfoSectionProps {
  profile: ProfileView;
  role: string;
  onRoleChange: (role: string) => void;
  canEdit?: boolean;
}

export const ProfileInfoSection: React.FC<ProfileInfoSectionProps> = ({ 
  profile, 
  role, 
  onRoleChange,
  canEdit = true
}) => (
  <SectionPaper sx={{ mb: 2, p: 1.5 }}>
    <SectionHeader icon={<PersonIcon sx={{ mr: 0.5 }} />} title="Profile Information" />
    <Stack spacing={1.5}>
      {/* Email, Organization, and Identity in horizontal layout */}
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={{ xs: 1.5, md: 2.5 }}>
        <Box sx={{ flex: 1 }}>
          <Typography variant="body2" color={THEME_COLORS.text.secondary} sx={{ fontSize: '0.8rem', mb: 0.25 }}>
            Email
          </Typography>
          <Typography variant="body2" sx={{ fontSize: '0.9rem' }}>
            {profile.email}
          </Typography>
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography variant="body2" color={THEME_COLORS.text.secondary} sx={{ fontSize: '0.8rem', mb: 0.25 }}>
            Organization
          </Typography>
          <Typography variant="body2" sx={{ fontSize: '0.9rem' }}>
            {profile.organization}
          </Typography>
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography variant="body2" color={THEME_COLORS.text.secondary} sx={{ fontSize: '0.8rem', mb: 0.25 }}>
            Identity
          </Typography>
          <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.85rem' }}>
            {profile.identity}
          </Typography>
        </Box>
      </Stack>

      {/* Role Assignment*/}
      <Box>
        <Typography variant="body2" color={THEME_COLORS.text.secondary} sx={{ fontSize: '0.8rem', mb: 0.5 }}>
          Current Role
        </Typography>
        <RoleSelect 
          value={role} 
          onChange={onRoleChange} 
          initialValue={profile.role} 
          identity={profile.identity}
          disabled={!canEdit}
        />
      </Box>
    </Stack>
  </SectionPaper>
);